import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export interface ComparisonLabels {
  portfolio1: string;
  portfolio2: string;
  portfolio1Short: string;
  portfolio2Short: string;
  portfolio1Perc: string;
  portfolio2Perc: string;
}

export const ComparisonLabelsContext = React.createContext<ComparisonLabels | null>(null);

export function useComparisonLabels(): ComparisonLabels {
  const ctx = useContext(ComparisonLabelsContext);
  const { t } = useTranslation();
  if (ctx) return ctx;
  return {
    portfolio1: t('portafoglioCompare.portafoglio1'),
    portfolio2: t('portafoglioCompare.portafoglio2'),
    portfolio1Short: t('portafoglioCompare.portafoglio1'),
    portfolio2Short: t('portafoglioCompare.portafoglio2'),
    portfolio1Perc: t('portafoglioCompare.portafoglio1Perc'),
    portfolio2Perc: t('portafoglioCompare.portafoglio2Perc'),
  };
}
